import { useNavigate } from "react-router-dom";

// project imports
import config from "config";
import { GuardProps } from "types";
import { useEffect } from "react";
import { useAppSelector } from "store/hooks";

// ==============================|| GUEST GUARD ||============================== //

/**
 * Guest guard for routes having no auth required
 * @param {PropTypes.node} children children element/node
 */

const GuestGuard = ({ children }: GuardProps) => {
  const { isLoggedIn } = useAppSelector((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(config.defaultPath, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return children;
};

export default GuestGuard;
